cockpitApp.directive('flightOverviewTabs', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/flight-overview-tabs',
    controllerAs: 'flightOverviewTabsCtrl',
    controller: 'flightOverviewTabsController'
  };
});
